module.exports = __webpack_public_path__ + "static/media/logo-largo.2f4e9f41.png";